<div class="page-404">
  <h1>
    Error 404: Page Not Found
  </h1>
</div>
